<script>
export default {
    mounted() {
        if (!document.getElementById("riskPointsEnabled").checked) {
            const snapshotsCheckbox = document.getElementById("snapshotsEnabled");
            snapshotsCheckbox.disabled = true;
            snapshotsCheckbox.checked = false;
        }
    },
    methods: {
        riskPointsToggled(enabled) {
            const snapshotsCheckbox = document.getElementById("snapshotsEnabled");
            snapshotsCheckbox.disabled = !enabled;

            if (!enabled) {
                snapshotsCheckbox.checked = false;
            }
        },
    },
};
</script>

<style scoped lang="scss"></style>
